import { useCallback } from 'react';
import { CommonActions } from '@react-navigation/native';
import { useOpenDeeplink } from '../../../../hooks';
import {
  HOME_TAB_ROUTE_NAME,
  TAB_HOST_ROUTE_NAME,
  useRootStackNavigation,
} from '../../../../hooks/useRootNavigation';
import { isWeb } from '../../../isWeb';

// 홈 상단탭 선택값. HomeContents 가 route.params.selected 를 id/screen_name 으로 매칭한다.
const HOME_SELECTED_TAB = 'today';

export const useMoveToHome = () => {
  const navigation = useRootStackNavigation();

  const { openDeeplink } = useOpenDeeplink();

  return useCallback(() => {
    const navigationState = navigation.getState();

    const hasStacks = navigationState.routes.length > 1;
    const hasHomeScreen =
      navigationState.routes.filter(
        route => route.name === 'Home' || route.name === 'tab',
      ).length > 0;

    if (isWeb) {
      // 웹에는 deeplink 경로가 없으므로 루트 스택을 tab 하나로 초기화한다(쌓인 화면 정리).
      // 중첩 params({ screen, params })는 tab 네비게이터가 새로 마운트될 때 초기 상태로
      // 반영되고(useNavigationBuilder), TabRouter.getRehydratedState 가 나머지 탭 라우트를
      // 채워주므로 하단탭 구성은 그대로 유지된다.
      //
      // navigate 가 아니라 reset 인 이유: 이미 tab 에 있으면 navigate 는 현재 선택 탭을 두고
      // params 만 머지해서 쌓인 스택이 남는다. 홈 버튼은 항상 초기 상태로 가야 한다.
      //
      // CommonActions 를 쓰는 이유: RootStackParamList 의 인덱스 시그니처가 `params?: string`
      // 이라 중첩 params 객체를 타입드 API 로는 넘길 수 없다.
      navigation.dispatch(
        CommonActions.reset({
          index: 0,
          routes: [
            {
              name: TAB_HOST_ROUTE_NAME,
              params: {
                screen: HOME_TAB_ROUTE_NAME,
                params: { selected: HOME_SELECTED_TAB },
              },
            },
          ],
        }),
      );
      return;
    }

    if (hasHomeScreen && hasStacks) {
      navigation.popToTop();
      return;
    }

    openDeeplink('ably://home/today');
  }, [navigation, openDeeplink]);
};
